/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { KonturBonusSignIcon16Light } from './KonturBonusSignIcon16Light';
import { KonturBonusSignIcon16Regular } from './KonturBonusSignIcon16Regular';
import { KonturBonusSignIcon16Solid } from './KonturBonusSignIcon16Solid';
import { KonturBonusSignIcon20Light } from './KonturBonusSignIcon20Light';
import { KonturBonusSignIcon20Regular } from './KonturBonusSignIcon20Regular';
import { KonturBonusSignIcon20Solid } from './KonturBonusSignIcon20Solid';
import { KonturBonusSignIcon24Regular } from './KonturBonusSignIcon24Regular';
import { KonturBonusSignIcon24Solid } from './KonturBonusSignIcon24Solid';
import { KonturBonusSignIcon32Regular } from './KonturBonusSignIcon32Regular';
import { KonturBonusSignIcon64Regular } from './KonturBonusSignIcon64Regular';
var sizes = {
    16: {
        light: KonturBonusSignIcon16Light,
        regular: KonturBonusSignIcon16Regular,
        solid: KonturBonusSignIcon16Solid,
    },
    20: {
        light: KonturBonusSignIcon20Light,
        regular: KonturBonusSignIcon20Regular,
        solid: KonturBonusSignIcon20Solid,
    },
    24: {
        regular: KonturBonusSignIcon24Regular,
        solid: KonturBonusSignIcon24Solid,
    },
    32: {
        regular: KonturBonusSignIcon32Regular,
    },
    64: {
        regular: KonturBonusSignIcon64Regular,
    },
};
export var KonturBonusSignIcon = forwardRef('KonturBonusSignIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
